import {
  REQUEST_SETTINGS_LIST,
  RECEIVE_SETTINGS_LIST,
  RECEIVE_PARTNER_SETTINGS_LIST,
  FETCH_SETTINGS_LIST_FAIL,
  REQUEST_PARTNER_SETTINGS_LIST
} from "../actionType/Constants";

export function partnerSettingsReducer(
  state = {
    isFetching: false
  },
  action
) {
  // Request Settings
  switch (action.type) {
    case REQUEST_PARTNER_SETTINGS_LIST:
      return Object.assign({}, state, {
        isFetching: true
      });
    // Receive Settings
    case RECEIVE_PARTNER_SETTINGS_LIST:
      return Object.assign({}, state, {
        isFetching: false,
        partnerSettings: action.payload
      });
    // Fetch Settings fail
    case FETCH_SETTINGS_LIST_FAIL: {
      return {
        ...state,
        settings: state.settings ? state.settings : action.payload,
        isFetching: false
      };
    }
    default:
      return state;
  }
}
